import { theme } from '@prophecy/theme';
import styled from 'styled-components';
export const ErrorTrace = styled.pre `
  background: ${theme.colors.error50};
  color: ${theme.colors.error500};
  padding: ${theme.spaces.x12};
  font-size: ${theme.fontSizes.x13};
  overflow: auto;
  /* <pre> defaults to \`white-space: pre\`, so a long single-line error (a
     compressed SQL statement, a one-line stack trace) extends horizontally
     and forces the user to scroll sideways to read it — which is especially
     painful inside the toast detail dialog where the container is narrow.
     Switch to \`pre-wrap\` so newlines/indentation are still preserved but
     long lines wrap into the container, and \`overflow-wrap: anywhere\` so
     long unbroken tokens (URLs, hex hashes) break instead of overflowing. */
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
